export default {
  header: {
    title: "Templates d'Architecture",
    subtitle: "Démarrez rapidement avec nos templates préconfigurés et prêts à déployer"
  },
  search: {
    placeholder: "Rechercher..."
  },
  filters: {
    allCategories: "Tous",
    allProviders: "Tous",
    allDifficulties: "Tous"
  },
  categories: {
    webApp: "Web App",
    microservices: "Microservices",
    dataProcessing: "Data Processing",
    serverless: "Serverless",
    network: "Network",
    security: "Security"
  },
  providers: {
    azure: "Azure",
    aws: "AWS",
    gcp: "GCP",
    multiCloud: "Multi-Cloud"
  },
  difficulties: {
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé"
  },
  stats: {
    templatesAvailable_one: "{{count}} template disponible",
    templatesAvailable_other: "{{count}} templates disponibles"
  },
  card: {
    popular: "⭐ POPULAIRE",
    resources: "Ressources:",
    deployment: "Déploiement:",
    preview: "Aperçu",
    use: "Utiliser"
  },
  emptyState: {
    title: "Aucun template trouvé",
    subtitle: "Essayez de modifier vos filtres de recherche"
  },
  preview: {
    resources: "Ressources",
    deployment: "Déploiement",
    difficulty: "Difficulté",
    featuresTitle: "Fonctionnalités incluses",
    close: "Fermer",
    useTemplate: "Utiliser ce template"
  },
  alerts: {
    usingTemplate: "Utilisation du template: {{name}}"
  },
  templateData: {
    template1: {
      name: "Application Web 3-Tier",
      description: "Architecture classique avec frontend, backend API et base de données. Inclut load balancer, auto-scaling et cache Redis.",
      features: [
        "Auto-scaling",
        "Load Balancer",
        "Cache Redis",
        "SQL Database",
        "CDN",
        "Application Insights"
      ]
    },
    template2: {
      name: "Infrastructure Microservices",
      description: "Architecture microservices avec Kubernetes (AKS), service mesh Istio, et monitoring complet.",
      features: [
        "Kubernetes AKS",
        "Service Mesh Istio",
        "API Gateway",
        "Event Hub",
        "Container Registry",
        "Monitoring Prometheus"
      ]
    },
    template3: {
      name: "Serverless API",
      description: "API REST serverless avec Azure Functions, API Management et Cosmos DB pour une scalabilité infinie.",
      features: [
        "Azure Functions",
        "API Management",
        "Cosmos DB",
        "App Service Plan",
        "Key Vault",
        "Application Insights"
      ]
    },
    template4: {
      name: "Data Lake & Analytics",
      description: "Pipeline de données avec ingestion, transformation, stockage et analyse. Inclut Data Factory et Synapse Analytics.",
      features: [
        "Data Lake Storage",
        "Data Factory",
        "Synapse Analytics",
        "Stream Analytics",
        "Event Hubs",
        "Power BI"
      ]
    },
    template5: {
      name: "Réseau Hub-Spoke",
      description: "Topologie réseau Hub-Spoke avec VPN Gateway, Firewall et ExpressRoute pour connectivité hybride.",
      features: [
        "Virtual Network",
        "VPN Gateway",
        "Azure Firewall",
        "ExpressRoute",
        "Network Security Groups",
        "Bastion"
      ]
    },
    template6: {
      name: "Landing Zone Enterprise",
      description: "Landing zone complète avec gouvernance, sécurité et conformité pour entreprise. Basée sur le CAF.",
      features: [
        "Management Groups",
        "Policy",
        "RBAC",
        "Security Center",
        "Sentinel",
        "Log Analytics"
      ]
    },
    template7: {
      name: "E-Commerce Platform",
      description: "Plateforme e-commerce complète avec catalogue produits, panier, paiement et gestion commandes.",
      features: [
        "EC2 Auto Scaling",
        "RDS MySQL",
        "ElastiCache",
        "CloudFront",
        "S3",
        "Lambda"
      ]
    },
    template8: {
      name: "ML Training Pipeline",
      description: "Pipeline complet pour entraînement de modèles ML avec SageMaker, stockage S3 et déploiement automatique.",
      features: [
        "SageMaker",
        "S3",
        "Lambda",
        "Step Functions",
        "ECR",
        "CloudWatch"
      ]
    },
    template9: {
      name: "Static Website",
      description: "Site web statique avec CI/CD, hébergé sur S3 avec CloudFront et certificat SSL.",
      features: [
        "S3",
        "CloudFront",
        "Route 53",
        "ACM Certificate",
        "CodePipeline",
        "CloudWatch"
      ]
    },
    template10: {
      name: "IoT Data Processing",
      description: "Architecture IoT avec ingestion temps réel, traitement et visualisation des données capteurs.",
      features: [
        "Cloud IoT Core",
        "Pub/Sub",
        "Dataflow",
        "BigQuery",
        "Cloud Storage",
        "Data Studio"
      ]
    },
    template11: {
      name: "Multi-Cloud DR",
      description: "Solution de disaster recovery multi-cloud avec réplication Azure-AWS pour haute disponibilité.",
      features: [
        "Site Recovery",
        "VPN",
        "Traffic Manager",
        "Route 53",
        "S3 Replication",
        "Monitoring"
      ]
    },
    template12: {
      name: "CI/CD Pipeline",
      description: "Pipeline CI/CD complet avec tests automatisés, staging et déploiement blue-green.",
      features: [
        "GitHub Actions",
        "Docker",
        "Kubernetes",
        "Terraform",
        "Monitoring",
        "Notifications"
      ]
    }
  }
};
